import styled from "styled-components";

export const StyledSectionWrapper = styled.div`
  background-image: url("./images/first-slider-line.png");
  background-repeat: no-repeat;
  background-position: 0% 60%;
  position: relative;
  z-index: 1;
  
  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    margin-bottom: -80px;
    background-size: 100% auto;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    background-position: 0 60%;
    margin-bottom: -160px;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.lg}) {
    background-position: 0 80px;
  }
`;

export const StyledTitle = styled.div`
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.161738px;
  color: #96a8be;
  padding: 0 8%;
  text-align: left;
  margin: 54px auto 10px;

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    text-align: center;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    margin-top: 0;
  }
`;

export const StyledDescriptions = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 35px;
  padding: 0 8%;
  text-align: left;
  margin-bottom: 66px;
  color: #f3f8ff;
  
  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    text-align: center;
    max-width: 650px;
    margin: 10px auto 30px;
    padding: 0;
    font-size: 32px;
    line-height: 40px;
  }
`;
